/**
 * @file MoldYourFuture.jsx
 * @description Mold Your Future Anmeldeseite
 */

import './MoldYourFuture.scss';

export default function MoldYourFuture() {
    return (
        <div className="container">
            <br/>
            <div className="myf-title">
                <h1>Karriere-Freitag @Fakuma Messe</h1>
            </div>
            <br/>
            <div className="myf-image">
                <img src="https://firebasestorage.googleapis.com/v0/b/azubi-homepage-prod-1-66fbb.appspot.com/o/Sonstiges%2F93503591-12b7-4d31-9332-9b84a697de01_PM_FAKUMA_mold_your_future_2026_01_DE-scaled.webp?alt=media&token=5615089c-f3c3-432d-b148-90debddd385c" width={500}/>
            </div>
            <br/>
            <div className="myf-content">
                <p>Unter dem Motto <b>„Mold your dreams, mold your future“</b> veranstaltet die Fakuma-Messe am <b>Freitag, 
                    16. Oktober 2026</b> die zweite Auflage des <a href="https://www.fakuma-messe.de/specials/lets-go-fakuma-karriere-freitag-fuer-schueler-studenten-und-berufseinsteiger/">Karriere-Freitags</a>. Vor Ort bieten unsere Experten sowie 
                    ein rund 30-köpfiges Azubi-Team spannende Einblicke in die Welt der Kunststofftechnik. <b><i>Aus erster 
                    Hand berichten die Jugendlichen</i></b>, welche vielfältigen Karrieremöglichkeiten ARBURG bereithält und 
                    wie die Zukunft in dieser innovativen Branche aussehen kann.
                    <br/>
                    <br/>
                    <b>Persönlicher Empfang</b>: Unsere Auszubildenden begrüßen <b><i>Dich</i></b> direkt an den beiden Eingangsbereichen 
                    der Messe.</p>
            </div>
            <div className="myf-register-btn">
                <a href="https://www.schall-registrierung.de/login.php?code=CCD2R-T18Q5">Jetzt registrieren</a>
            </div>
        </div>
    )
}